export type SpanStyle = {
  color: string; // hex color
  colorMix: number; // 0-1 transparency
  selectable?: boolean;
  data?: number;
};

export type Span = SpanStyle & {
  start: number; // cell start index
  end: number; // cell end index
};

export type RenderStyle = "Edges" | "CellSoft" | "CellSharp" | "SolidSoft" | "SolidSharp";

export function flattenSpan(span: Span) {
  const result: number[] = [];

  for (let i = span.start; i <= span.end; i++) {
    result.push(i);
  }

  return result;
}

export function flattenSpans(spans: Span[]) {
  return spans.flatMap(flattenSpan);
}

export function flipEnds(span: Span): Span {
  if (!span) {
    return span;
  }

  const doFlip = span.start > span.end;

  return {
    ...span,
    start: doFlip ? span.end : span.start,
    end: doFlip ? span.start : span.end
  };
}

export function cellsToSpans(
  cells: number[],
  totalCells: number,
  createSpanCb: (start: number, end: number) => Span,
  disabledIndexes: number[] = []
): Span[] {
  const result: Span[] = [];

  let spanStart = null;

  for (let i = 0; i < totalCells; i++) {
    if (cells.includes(i) && !disabledIndexes.includes(i) && spanStart === null) {
      spanStart = i;
      continue;
    }

    if ((!cells.includes(i) || disabledIndexes.includes(i)) && spanStart !== null) {
      result.push(createSpanCb(spanStart, i - 1));
      spanStart = null;
    }
  }

  if (spanStart != null) {
    result.push(createSpanCb(spanStart, totalCells - 1));
  }

  return result;
}

export function isCellInSpans(cell: number, spans: Span[]) {
  return flattenSpans(spans).includes(cell);
}

export const PeriodColors = {
  Booked: "#20aaa0",
  WorkRequest: "#f06020",
  Availability: "#cddc39",
  Selected: "#6050af",
  None: "#ffffff"
};
